import { Spinner } from "react-bootstrap";
/**
 *
 * @param {Object} param
 * @param {string} param.loadingMessage
 * @returns
 */
const CommonLoader = ({ loadingMessage }) => {
  return (
    <div className="text-center py-5">
      <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-2">{loadingMessage}</p>
    </div>
  );
};

export default CommonLoader;
